// import React from "react";
// import styles from "./Input.module.scss";
// import { Controller } from "react-hook-form";
// import withLabelAndError from "../withLabelAndError";

// const Input = (props) => {
//   const { control, register, validations, name, placeholder, type, ...rest } =
//     props;

//   const renderInput = (field = {}) => (
//     <input
//       {...field}
//       {...rest}
//       id={name}
//       type={type || "text"}
//       className={styles.inputField}
//       placeholder={placeholder}
//     />
//   );

//   if (control) {
//     return (
//       <Controller
//         control={control}
//         rules={validations}
//         name={name}
//         render={({ field }) => renderInput(field)}
//       />
//     );
//   } else {
//     const field = register && register(name, validations);
//     return renderInput(field);
//   }
// };

// const InputWithLabelAndError = withLabelAndError(Input);

// export default InputWithLabelAndError;
// export { Input };



import React from "react";
import styles from "./Input.module.scss";
import {
  Controller,
 type  Control,
 type  FieldValues,
type  RegisterOptions,
type  UseFormRegister,
type  Path,
} from "react-hook-form";
import withLabelAndError from "../withLabelAndError";

interface InputProps<T extends FieldValues = FieldValues> {
  control?: Control<T>; // Controlled component
  register?: UseFormRegister<T>; // Uncontrolled component
  validations?: RegisterOptions<T, Path<T>>; 

  name: Path<T>; // 👈 Must be a Path<T>, not string
  placeholder?: string;
  type?: string;
  [key: string]: any; // Allow extra props like className, etc.
}

const Input = <T extends FieldValues = FieldValues>({
  control,
  register,
  validations,
  name,
  placeholder,
  type,
  showCheckMark,
  ...rest
}: InputProps<T> & { showCheckMark?: boolean }) => {
  const renderInput = (field: any = {}) => {
    const isMobile =
      typeof name === "string" &&
      (name.toLowerCase().includes("mobileno") ||
        name.toLowerCase().includes("mobilenumber"));

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (isMobile) {
        const allowedKeys = [
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
          "ArrowUp",
          "ArrowDown",
          "Home",
          "End",
        ];
        if (allowedKeys.includes(e.key)) {
          return;
        }
        if (
          (e.ctrlKey || e.metaKey) &&
          ["a", "c", "v", "x"].includes(e.key.toLowerCase())
        ) {
          return;
        }
        if (!/^[0-9]$/.test(e.key)) {
          e.preventDefault();
        }
        const isSelectionActive =
          (e.currentTarget.selectionEnd ?? 0) -
            (e.currentTarget.selectionStart ?? 0) >
          0;
        if (
          e.currentTarget.value.length >= 10 &&
          !isSelectionActive &&
          /^[0-9]$/.test(e.key)
        ) {
          e.preventDefault();
        }
      }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (isMobile) {
        let val = e.target.value.replace(/\D/g, "");
        if (val.length > 10) {
          val = val.slice(0, 10);
        }
        e.target.value = val;
      }
      if (field.onChange) {
        field.onChange(e);
      }
      if (rest.onChange) {
        rest.onChange(e);
      }
    };

    return (
      <div className={styles.inputWrapper}>
        <input
          {...field}
          {...rest}
          id={name}
          type={type || "text"}
          className={styles.inputField}
          placeholder={placeholder}
          onKeyDown={handleKeyDown}
          onChange={handleChange}
        />
        {showCheckMark && <span className={styles.checkMark}>✓</span>}
      </div>
    );
  };

  if (control) {
    return (
      <Controller
        control={control}
        // rules={validations}
         {...(validations ? { rules: validations } : {})}
        name={name}
        render={({ field }) => renderInput(field)}
      />
    );
  } else if (register) {
    const field = register(name, validations);
    return renderInput(field);
  } else {
    return renderInput(); // fallback if neither control nor register is provided
  }
};

const InputWithLabelAndError = withLabelAndError(Input);

export default InputWithLabelAndError;
export { Input };
